import Text from '@eversports/klimt-primitives/legacy/Text'
import { assertNever } from '@eversports/klimt-utilities/assert-never'
import type { JSX } from 'react'

import { Localized } from '../localization/react'

interface Props {
  label?: JSX.Element
  variant?: 'default' | 'primary'
}

const NewBadge = ({ label, variant = 'default' }: Props) => {
  switch (variant) {
    case 'primary':
      return (
        <Text
          sx={{
            color: '#21A696',
            padding: '2px 8px',
            borderRadius: '8px',
            border: '1px solid',
            borderColor: '#21A696',
            fontSize: '14px',
            lineHeight: '20px',
            fontWeight: '500',
            backgroundColor: 'transparent',
            textTransform: 'none',
          }}
        >
          {label || <Localized id="navigation-tab-new-tag" />}
        </Text>
      )
    case 'default':
      return (
        <Text
          sx={{
            color: 'white',
            padding: 0.5,
            borderRadius: 0.5,
            backgroundColor: 'red',
            textTransform: 'uppercase',
            fontSize: '9px',
            lineHeight: '11px',
            fontWeight: 'bold',
          }}
        >
          {label || <Localized id="navigation-tab-new-tag" />}
        </Text>
      )
    default:
      return assertNever(variant)
  }
}

export default NewBadge
